import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import { AnalyticsContext } from '@carvana/eventable-clickstream';

export const Wrapper = styled.div`
  display: flex;
  max-width: 1800px;
  margin: 0 auto;
  padding: 8px 40px 0px 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
  background: #ffffff;
  width: 100%;
`;

export const Banner = styled.div`
  background-color: #e03131;
  color: #ffffff;
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font: normal 1.125rem / 28px Inter, sans-serif;
  border-radius: 8px;
  border: 1px solid #e27808;
  width: 100%;

  p {
    text-align: left;
    margin: 0;
    padding: 0;

    @media (min-width: 768px) {
      text-align: center;
    }
  }

  a {
    color: #ffffff;
    text-decoration: none;
    background: #5b1313;
    border-radius: 8px;
    height: 32px;
    padding: 6px 16px;
    gap: 8px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    gap: 16px;
  }
`;

const defaultProps = {
  user: {
    given_name: '',
    family_name: '',
    user_id: ''
  }
};

const ImpersonationBanner = (props = defaultProps) => {
  const { user } = props;
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent('header - banner - viewed banner', {
      bannerType: 'impersonation-banner'
    });
  }, []);

  return (
    <Wrapper>
      <Banner data-testid="impersonation-banner">
        <p>
          Currently Impersonating User:{' '}
          <strong>
            {user?.given_name} {user?.family_name}
          </strong>
        </p>
        <a
          href={`/manageuser/deimpersonate?i=userdetails&returnUrl=/managecustomer?userid=${user?.user_id}`}
          target="_self"
          aria-label="stop impersonating"
          onClick={() => {
            trackEvent('header - banner - dismissed banner', {
              bannerType: 'impersonation-banner'
            });
          }}
        >
          Stop
        </a>
      </Banner>
    </Wrapper>
  );
};

export default ImpersonationBanner;
